import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
    path: 'appointment._id',
  })

  return {
    variables: { appointment_id },
    pause: !appointment_id,
  }
}
